import isPropValid from "@emotion/is-prop-valid";
import styled from "@emotion/styled";
import Typograph from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import React from 'react'

interface PaperWrapperProps {
    className?: string;
    title?: string;
    elevation?: number;
    padding?: string;
    children: React.ReactNode;
}

export default function PaperWrapper({ title, className, elevation = 6, padding = "1rem", children }: PaperWrapperProps) {
  return (
    <>
      <Typograph variant="h6">{title}</Typograph>
      <StyledPaper className={className} elevation={elevation} padding={padding}>
          {children}
      </StyledPaper>    
    </>
  )
}

const StyledPaper = styled(Paper, { shouldForwardProp: isPropValid, })(({ padding }: PaperWrapperProps) => ({
    width: "100%",
    borderRadius: "1rem",
    padding,
}));
